if (!customElements.get("script-lazy-load")) {
	class ScriptLazyLoad extends HTMLElement {
		constructor() {
			super();
			this._script = null;
			this._distance = 1000;
			this._rootNode = null;
			this._threshold = 0;
			this._observerOptions = {
				root: this.rootNode,
				rootMargin: `${this.distance}px`,
				threshold: this.threshold,
			};
			this._loadEvent = 'scriptlazyloaded';
		}

		get script() {
			return this._script ?? this.dataset.script;
		}

		set script(s) {
			this._script = s;
		}

		get distance() {
			return this.dataset.distance ? parseFloat(this.dataset.distance) : this._distance;
		}

		set distance(d) {
			this._distance = d;
		}

		get rootNode() {
			return this.dataset.rootNode ? document.querySelector(this.dataset.rootNode) : this._rootNode;
		}

		set rootNode(r) {
			this._rootNode = r;
		}

		get threshold() {
			return this.dataset.threshold ? JSON.parse(this.dataset.threshold) : this._threshold;
		}

		set threshold(t) {
			this._threshold = t;
		}

		get webWorkerEnabled() {
			return this.dataset.worker;
		}

		get debug() {
			return !!(this._debug || this.dataset.debug);
		}

		set debug(d) {
			this._debug = d;
		}

		get loadEvent() {
			return this.dataset.loadEvent || this._loadEvent;
		}

		set loadEvent(e) {
			this._loadEvent = e;
		}

		dispatchLoadEvent() {
			const event = new Event(this.loadEvent);
			window.dispatchEvent(Object.defineProperty(event, 'scriptLoaded', { value: this.script }));
		}

		onIntersect([entry], observer) {
			if (entry.isIntersecting) {
				if (!this.script) {
					return observer.disconnect();
				}

				const script = document.createElement('script');
				script.src = this.script;
				this.append(script);
				script.onload = this.dispatchLoadEvent.bind(this);

				observer.disconnect();
			}
		}

		createObserver() {
			const observer = new IntersectionObserver(this.onIntersect.bind(this), this._observerOptions);
			observer.observe(this);
		}

		connectedCallback() {
			this.createObserver();
		}
	}

	customElements.define('script-lazy-load', ScriptLazyLoad);
}